import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../components/Navbar";
import { motion, useAnimation } from "framer-motion";
import Footer from "../components/Footer";

const TransparentCard = ({ image, title, description, index, onImageClick }) => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({
      opacity: [0, 1],
      y: [50, 0],
      transition: {
        delay: index * 0.15,
        duration: 0.8,
        type: "spring",
        stiffness: 60
      }
    });
  }, [controls, index]);

  return (
    <motion.div
      className="w-full bg-white/30 backdrop-blur-md rounded-xl shadow-lg p-4 transition duration-300 transform hover:scale-105 hover:shadow-2xl cursor-pointer"
      animate={controls}
      initial={{ opacity: 0, y: 50 }}
      onClick={() => onImageClick(image)}
    >
      <div className="w-full h-48 bg-white/20 rounded mb-4 flex items-center justify-center overflow-hidden">
        <img
          src={image}
          alt={title}
          className="h-full object-contain transition duration-300"
          loading="lazy"
        />
      </div>
      <h2 className="text-base font-semibold text-black/90">{title}</h2>
      <p className="text-sm text-gray-700 mt-1">{description}</p>
    </motion.div>
  );
};

const Products = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);

  const products = [
    {
      id: 1,
      image: "assets/Product1.jpg",
      title: t("products.product1.title"),
      description: t("products.product1.description")
    },
    {
      id: 2,
      image: "assets/Product2.jpg",
      title: t("products.product2.title"),
      description: t("products.product2.description")
    },
    {
      id: 3,
      image: "assets/Product3.jpg",
      title: t("products.product3.title"),
      description: t("products.product3.description")
    },
    {
      id: 4,
      image: "assets/Product4.jpg",
      title: t("products.product4.title"),
      description: t("products.product4.description")
    },
    {
      id: 5,
      image: "assets/Product5.jpg",
      title: t("products.product5.title"),
      description: t("products.product5.description")
    },
    {
      id: 6,
      image: "assets/Product6.jpg",
      title: t("products.product6.title"),
      description: t("products.product6.description")
    }
  ];

  return (
    <div className="flex flex-col min-h-screen bg-cover bg-center" style={{ backgroundImage: "url('/assets/products_bg.jpg')" }}>
      <Navbar
        logo="/assets/logo-black.png"
        className="bg-black/50 backdrop-blur-sm fixed top-0 w-full z-50"
      />

      <div className="flex-grow pt-28 px-4 pb-12 max-w-screen-lg mx-auto">
        <h1 className="text-4xl font-bold text-white mb-8 text-center drop-shadow-lg">
          {t("products.title")}
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((product, index) => (
            <TransparentCard
              key={product.id}
              index={index}
              image={product.image}
              title={product.title}
              description={product.description}
              onImageClick={setSelectedImage}
            />
          ))}
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <motion.img
            src={selectedImage}
            alt="Zoomed Product"
            className="max-w-full max-h-[90vh] rounded-md shadow-2xl"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
          />
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Products;
